
<template>
    <div >
      <el-row class="info-list">
       <el-col :span="24" class="info-item" v-for="(item,index) in dataList" :key="index">
         <div class="content flx-justify-between " style="margin-right: 30px;">
           <div class="title">
            <img :src="item.img" alt="">
            {{item.title}}
          </div>
      
         </div>
        </el-col>
  
       <!-- 更多 .info-item -->
      </el-row>
    </div>
  </template>
  <script>
  
  
  /**
   * Index-1 component
   */
  export default {
    name:"accountAudit",
    components: {
    },
    data(){
      return {
          dataList:[
            {
              title:"公司或法人名 下的公共事业账单(水费、电费、天然气/煤气或互联网服务任一项",
              img:this.$ossUrl+'icons/platform/platformIcon1.png',
            },
        
          ]
      }
    },
    methods: {
     
    }
  };
  </script>
  <style src="./componentsIndex.css" scoped></style>